import React, { useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/Demo.css';

const Demo = () => {
  const videoRef = useRef(null);

  return (
    <div className="demo-page">
      <Helmet>
        <title>Product Demo | Xerowrite</title>
        <meta name="description" content="Watch our 2-minute product demo and see why Xerowrite delivers the highest response rates in direct mail." />
      </Helmet>
      {/* LOGO & TAGLINE */}
      <div className="demo-header">
        <Link to="/" className="demo-logo-link">
          <img 
            src="https://customer-assets.emergentagent.com/job_print-showcase-18/artifacts/w98y26hs_Xerowrite%20Logo%20New%20Pink.png" 
            alt="Xerowrite, Specialty Trade Print Supplier" 
            className="demo-logo"
          />
        </Link>
        <p className="demo-tagline">The Highest-Performing Direct Mail for Marketing Agencies</p>
      </div>

      {/* VIDEO */}
      <div className="demo-video-section">
        <div className="demo-video-container">
          <video
            ref={videoRef}
            className="demo-video"
            controls
            preload="auto"
            aria-label="Xerowrite product demonstration video showing handwritten-style direct mail postcards with fluorescent pink personalization"
            title="Xerowrite Direct Mail Product Demo Video"
          >
            <source 
              src="https://customer-assets.emergentagent.com/job_print-showcase-18/artifacts/h9gmy6gm_Clockwork%20Product%20Video%20-%202m.mp4" 
              type="video/mp4" 
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* STATS */}
      <div className="demo-stats">
        <div className="demo-stat">
          <div className="stat-title">Ordered Today</div>
          <div className="stat-subtitle">At the Post Office Tomorrow</div>
        </div>
        <div className="demo-stat">
          <div className="stat-title">Highest Response Rates</div>
          <div className="stat-subtitle">in Direct Mail</div>
        </div>
        <div className="demo-stat">
          <div className="stat-title">Next-Day Production</div>
          <div className="stat-subtitle">Built for Marketing Agencies</div>
        </div>
      </div>

      {/* CTA */}
      <div className="demo-cta-section">
        <h2 className="demo-cta-title">Ready to See What This Does for Your Agency?</h2>
        <p className="demo-cta-text">
          Call us or send a message and we will set up a live demo of the portal and build a proposal for your agency.
        </p>
        
        <div className="demo-cta-buttons">
          <a href="tel:8015097884" className="demo-btn demo-btn-primary">
            <Phone size={20} />
            Call 801.509.7884
          </a>
          <a href="mailto:mail@xerowrite.com" className="demo-btn demo-btn-outline">
            <Mail size={20} />
            Email mail@xerowrite.com
          </a>
        </div>
      </div>

      {/* FOOTER */}
      <div className="demo-footer">
        © Xerowrite, <a href="/">xerowrite.com</a>
      </div>
    </div>
  );
};

export default Demo;
